import { useTranslation } from 'react-i18next'
import { RenderModal, RenderModalProps } from '@/components/render-modal'
import { ModalContent, ButtonLink, ModalFooter } from './atom'
import { useModalStore } from '@/store/modal/modal-store'
import RaySyncIns from '@/services/raysync'
import { useRaysyncDownload } from '@/hooks/use-raysync-download'

export function RaysyncUpdateModal(props: RenderModalProps) {
  const { t } = useTranslation('output')
  const { submitting } = useModalStore()
  const { isLinux, centosUrl, ubuntuUrl, url } = useRaysyncDownload()
  const version = RaySyncIns.serverInfo[1] ? RaySyncIns.serverInfo[1].clientVersion : ''

  return (
    <RenderModal
      renderModalSize='small'
      title={t('raysync_update_modal_title')}
      submitting={submitting}
      haveCancel={false}
      haveConfirm={false}
      {...props}
    >
      <ModalContent>
        <div>{t('raysync_update_modal_content', { version })}</div>
      </ModalContent>
      <ModalFooter>
        {!isLinux ? (
          <ButtonLink href={url}>{t('raysync_update_modal_btn')}</ButtonLink>
        ) : (
          <>
            <ButtonLink href={ubuntuUrl}>{t('raysync_update_modal_btn_ubuntu')}</ButtonLink>
            <ButtonLink href={centosUrl}>{t('raysync_update_modal_btn_centos')}</ButtonLink>
          </>
        )}
      </ModalFooter>
    </RenderModal>
  )
}
